module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#business",
      toString: function () {
        return this.url;
      }
    }